const xTick = require('okCharts/pfmBarChart/xTick/xTick');

module.exports = xTick;
